<template>
  <div 
    class="sidebar" 
    :class="{ 'collapsed': getSidebarActualCollapsed() }" 
    :style="{ background: themeGradient }"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <div class="logo" @click="navigateToDashboard">
      <div class="logo-icon">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="8" cy="20" r="2" fill="#fff"/>
          <circle cx="17" cy="20" r="2" fill="#fff"/>
          <path d="M3 4H5L6.2 15.2C6.3 16.2 7.1 17 8.1 17H17.5C18.4 17 19.1 16.3 19.2 15.5L20.5 7H6" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h3 v-show="!getSidebarActualCollapsed()">{{ getBackendTitle() }}</h3>
    </div>

    <div class="nav-menu">
      <!-- 手機管理員專用導航 -->
      <template v-if="isMobileUser">
        <div
          class="nav-item"
          :class="{ 'active': currentRoute === 'dailyDelivery' }"
          @click="navigateTo('dailyDelivery')"
        >
          <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" fill="none"/>
            <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" fill="none"/>
          </svg>
          <span v-show="!getSidebarActualCollapsed()">當日配送</span>
        </div>
      </template>

      <!-- 普通管理員導航 -->
      <template v-else>
      <div
        class="nav-item"
        :class="{ 'active': currentRoute === 'orders' }"
        @click="navigateTo('orders')"
      >
        <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
          <line x1="9" y1="9" x2="15" y2="9" stroke="currentColor" stroke-width="2"/>
          <line x1="9" y1="15" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
        </svg>
        <span v-show="!getSidebarActualCollapsed()">訂單</span>
      </div>

      <div
        class="nav-item"
        :class="{ 'active': currentRoute === 'users' }"
        @click="navigateTo('users')"
      >
        <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" stroke-width="2"/>
          <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
        </svg>
        <span v-show="!getSidebarActualCollapsed()">會員</span>
      </div>

      <div
        class="nav-item"
        :class="{ 'active': currentRoute === 'products' }"
        @click="navigateTo('products')"
      >
        <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
          <line x1="8" y1="21" x2="16" y2="21" stroke="currentColor" stroke-width="2"/>
          <line x1="12" y1="17" x2="12" y2="21" stroke="currentColor" stroke-width="2"/>
        </svg>
        <span v-show="!getSidebarActualCollapsed()">商品</span>
      </div>

      <div
        class="nav-item"
        :class="{ 'active': currentRoute === 'inventoryCount' }"
        @click="navigateTo('inventoryCount')"
      >
        <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
          <path d="M7 8H17" stroke="currentColor" stroke-width="2"/>
          <path d="M7 12H17" stroke="currentColor" stroke-width="2"/>
          <path d="M7 16H13" stroke="currentColor" stroke-width="2"/>
        </svg>
        <span v-show="!getSidebarActualCollapsed()">庫存盤點</span>
      </div>

      <div
        class="nav-item"
        :class="{ 'active': currentRoute === 'categories' }"
        @click="navigateTo('categories')"
      >
        <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H9L11 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V19Z" stroke="currentColor" stroke-width="2"/>
        </svg>
        <span v-show="!getSidebarActualCollapsed()">商品分類</span>
      </div>

      <div
        class="nav-item"
        :class="{ 'active': currentRoute === 'purchase' }"
        @click="navigateTo('purchase')"
      >
        <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.828 14.828C15.5 14.156 16 13.207 16 12.172V12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12V12.172C8 13.207 8.5 14.156 9.172 14.828L12 17.656L14.828 14.828Z" stroke="currentColor" stroke-width="2"/>
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
        </svg>
        <span v-show="!getSidebarActualCollapsed()">進貨</span>
      </div>

      <div
        class="nav-item"
        :class="{ 'active': currentRoute === 'productRequests' }"
        @click="navigateTo('productRequests')"
      >
        <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 11.5C21.5 12.2 21.5 12.8 21 13.5L19.36 15.82C19.1 16.18 18.74 16.43 18.33 16.54L16.19 17.07C15.93 17.13 15.78 17.31 15.66 17.54L14.44 19.73C14.19 20.25 13.81 20.25 13.56 19.73L12.34 17.54C12.22 17.31 12.07 17.13 11.81 17.07L9.67 16.54C9.26 16.43 8.9 16.18 8.64 15.82L7 13.5C6.5 12.8 6.5 12.2 7 11.5L8.64 9.18C8.9 8.82 9.26 8.57 9.67 8.46L11.81 7.93C12.07 7.87 12.22 7.69 12.34 7.46L13.56 5.27C13.81 4.75 14.19 4.75 14.44 5.27L15.66 7.46C15.78 7.69 15.93 7.87 16.19 7.93L18.33 8.46C18.74 8.57 19.1 8.82 19.36 9.18L21 11.5Z" stroke="currentColor" stroke-width="2"/>
          <path d="M9 9L5 13L7 15" stroke="currentColor" stroke-width="2"/>
          <path d="M15 9L19 13L17 15" stroke="currentColor" stroke-width="2"/>
          <circle cx="12" cy="12" r="3" fill="currentColor"/>
        </svg>
        <span v-show="!getSidebarActualCollapsed()">產品代尋留言板</span>
        <div v-if="unreadRequestsCount > 0" class="unread-badge">
          {{ unreadRequestsCount > 99 ? '99+' : unreadRequestsCount }}
        </div>
      </div>

      <div
        class="nav-item"
        :class="{ 'active': currentRoute === 'websiteSettings' }"
        @click="navigateTo('websiteSettings')"
      >
        <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2"/>
          <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2"/>
          <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="2"/>
          <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="2"/>
          <polyline points="10,9 9,9 8,9" stroke="currentColor" stroke-width="2"/>
        </svg>
        <span v-show="!getSidebarActualCollapsed()">網站設定</span>
      </div>

      <div
        class="nav-item"
        :class="{ 'active': currentRoute === 'costCalculator' }"
        @click="navigateTo('costCalculator')"
      >
        <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="4" width="16" height="16" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
          <line x1="9" y1="9" x2="15" y2="9" stroke="currentColor" stroke-width="2"/>
          <line x1="9" y1="15" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
          <line x1="12" y1="6" x2="12" y2="18" stroke="currentColor" stroke-width="2"/>
          <circle cx="12" cy="12" r="2" stroke="currentColor" stroke-width="2"/>
        </svg>
        <span v-show="!getSidebarActualCollapsed()">算錢工具</span>
      </div>

      <div
        class="nav-item"
        :class="{ 'active': currentRoute === 'invoiceManagement' }"
        @click="navigateTo('invoiceManagement')"
      >
        <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2"/>
          <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2"/>
          <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="2"/>
          <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="2"/>
          <polyline points="10,9 9,9 8,9" stroke="currentColor" stroke-width="2"/>
        </svg>
        <span v-show="!getSidebarActualCollapsed()">發票管理</span>
      </div>

      <div
        class="nav-item"
        :class="{ 'active': currentRoute === 'deliveryTracking' }"
        @click="navigateTo('deliveryTracking')"
      >
        <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" fill="none"/>
          <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" fill="none"/>
          <path d="M8 21L16 21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <span v-show="!getSidebarActualCollapsed()">配送員追蹤</span>
      </div>

      <div
        class="nav-item"
        :class="{ 'active': currentRoute === 'supplier' }"
        @click="navigateTo('supplier')"
      >
        <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
          <path d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.2573 9.77251 19.9887C9.5799 19.7201 9.31074 19.5176 9 19.41C8.69838 19.2769 8.36381 19.2372 8.03941 19.296C7.71502 19.3548 7.41568 19.5095 7.18 19.74L7.12 19.8C6.93425 19.986 6.71368 20.1335 6.47088 20.2341C6.22808 20.3348 5.96783 20.3866 5.705 20.3866C5.44217 20.3866 5.18192 20.3348 4.93912 20.2341C4.69632 20.1335 4.47575 19.986 4.29 19.8C4.10405 19.6143 3.95653 19.3937 3.85588 19.1509C3.75523 18.9081 3.70343 18.6478 3.70343 18.385C3.70343 18.1222 3.75523 17.8619 3.85588 17.6191C3.95653 17.3763 4.10405 17.1557 4.29 16.97L4.35 16.91C4.58054 16.6743 4.73519 16.375 4.794 16.0506C4.85282 15.7262 4.81312 15.3916 4.68 15.09C4.55324 14.7942 4.34276 14.542 4.07447 14.3643C3.80618 14.1866 3.49179 14.0913 3.17 14.09H3C2.46957 14.09 1.96086 13.8793 1.58579 13.5042C1.21071 13.1291 1 12.6204 1 12.09C1 11.5596 1.21071 11.0509 1.58579 10.6758C1.96086 10.3007 2.46957 10.09 3 10.09H3.09C3.42099 10.0823 3.742 9.97512 4.01062 9.78251C4.27925 9.5899 4.48167 9.32074 4.59 9.01C4.72312 8.70838 4.76282 8.37381 4.704 8.04941C4.64519 7.72502 4.49054 7.42568 4.26 7.19L4.2 7.13C4.01405 6.94425 3.86653 6.72368 3.76588 6.48088C3.66523 6.23808 3.61343 5.97783 3.61343 5.715C3.61343 5.45217 3.66523 5.19192 3.76588 4.94912C3.86653 4.70632 4.01405 4.48575 4.2 4.3C4.38575 4.11405 4.60632 3.96653 4.84912 3.86588C5.09192 3.76523 5.35217 3.71343 5.615 3.71343C5.87783 3.71343 6.13808 3.76523 6.38088 3.86588C6.62368 3.96653 6.84425 4.11405 7.03 4.3L7.09 4.36C7.32568 4.59054 7.62502 4.74519 7.94941 4.804C8.27381 4.86282 8.60838 4.82312 8.91 4.69H9C9.29577 4.56324 9.54802 4.35276 9.72569 4.08447C9.90337 3.81618 9.99872 3.50179 10 3.18V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z" stroke="currentColor" stroke-width="2"/>
        </svg>
        <span v-show="!getSidebarActualCollapsed()">廠商進貨</span>
      </div>
      </template>

    </div>

    <div class="special-action">
      <div
        class="nav-item logout-item"
        :style="{ background: themeGradient }"
        @click="showLogoutModal"
      >
        <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" stroke-width="2"/>
          <polyline points="16,17 21,12 16,7" stroke="currentColor" stroke-width="2"/>
          <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2"/>
        </svg>
        <span v-show="!getSidebarActualCollapsed()">登出</span>
      </div>
    </div>

    <!-- 登出確認模態框 -->
    <CustomModal
      :open="logoutModalVisible"
      title="確認登出"
      :width="400"
      ok-text="確定登出"
      cancel-text="取消"
      @ok="confirmLogout"
      @cancel="logoutModalVisible = false"
      @update:open="logoutModalVisible = $event"
    >
      <div style="padding: 8px 0;">
        <p style="margin: 0; font-size: 14px; color: #333; line-height: 1.6;">
          確定要登出嗎？
        </p>
      </div>
    </CustomModal>

  </div>
</template>

<script setup>
import { computed, watch, onMounted, onUnmounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useUserStore } from '../stores/user'
import { useProductRequestsStore } from '../stores/productRequests'
import { useBackendSettings } from '../stores/backendSettings'
import CustomModal from './CustomModal.vue'

const router = useRouter()
const route = useRoute()
const userStore = useUserStore()
const productRequestsStore = useProductRequestsStore()
const { 
  loadBackendConfig, 
  getBackendTitle, 
  getPrimaryColor,
  getSidebarCollapsed,
  setSidebarCollapsed,
  setSidebarHovered,
  getSidebarHovered,
  getSidebarActualCollapsed
} = useBackendSettings()

// 未讀留言數量（從 store 獲取）
const unreadRequestsCount = computed(() => productRequestsStore.unreadCount)

// 動態主題色彩
const primaryColor = computed(() => getPrimaryColor())

// 生成主題色彩的漸層
const themeGradient = computed(() => {
  const color = primaryColor.value
  // 將主色彩轉換為較深的版本用於漸層
  const darkerColor = adjustColorBrightness(color, -20)
  return `linear-gradient(180deg, ${color} 0%, ${darkerColor} 100%)`
})

// 調整顏色亮度的輔助函數
function adjustColorBrightness(color, amount) {
  const usePound = color[0] === '#'
  const col = usePound ? color.slice(1) : color
  
  const num = parseInt(col, 16)
  let r = (num >> 16) + amount
  let g = (num >> 8 & 0x00FF) + amount
  let b = (num & 0x0000FF) + amount
  
  r = r > 255 ? 255 : r < 0 ? 0 : r
  g = g > 255 ? 255 : g < 0 ? 0 : g
  b = b > 255 ? 255 : b < 0 ? 0 : b
  
  return (usePound ? '#' : '') + (r << 16 | g << 8 | b).toString(16).padStart(6, '0')
}

// 檢查是否為手機管理員（chengshe帳號）
const isMobileUser = computed(() => {
  return userStore.user?.username === 'chengshe'
})

// 當前路由 - 改進的邏輯來正確匹配導航高亮
const currentRoute = computed(() => {
  // 使用 route.path 來確保響應式更新
  const currentPath = route.path
  const currentName = route.name

  // 處理特殊路由映射
  const routeMapping = {
    '/orders': 'orders',
    '/return-requests': 'orders', // 申請退貨總表頁面歸屬於訂單管理
    '/manual-invoice': 'manualInvoice',
    '/invoice-management': 'invoiceManagement',
    '/users': 'users',
    '/products': 'products',
    '/products/create': 'products',
    '/categories': 'categories',
    '/inventory-count': 'inventoryCount',
    '/purchase': 'purchase',
    '/purchase/history': 'purchase',
    '/purchase-order-history': 'purchase',

    '/supplier': 'supplier',
    '/product-requests': 'productRequests',

    '/website-settings': 'websiteSettings',
    '/cost-calculator': 'costCalculator',
    '/daily-delivery': 'dailyDelivery',
    '/delivery-tracking': 'deliveryTracking',
    '/dashboard': 'dashboard',
    '/sales-statistics': 'dashboard', // 銷售統計歸屬於儀表板
    '/weekly-sales-statistics': 'dashboard' // 週平均銷售統計歸屬於儀表板
  }

  // 首先檢查完全匹配
  if (routeMapping[currentPath]) {
    return routeMapping[currentPath]
  }

  // 檢查路徑前綴匹配（用於子路由，如 /products/edit/123）
  for (const [path, navName] of Object.entries(routeMapping)) {
    if (currentPath.startsWith(path + '/')) {
      return navName
    }
  }

  // 如果沒有匹配到，使用路由名稱
  return currentName || ''
})

// 導航到儀表板
function navigateToDashboard() {
  navigateTo('dashboard');
}

// 導航到指定頁面
function navigateTo(routeName) {
  const targetRoute = router.options.routes.find(r => r.name === routeName);

  if (targetRoute) {
    // 檢查是否點擊的是當前頁面
    const currentPath = router.currentRoute.value.path;
    const targetPath = targetRoute.path;

    if (currentPath === targetPath) {
      // 如果是同一個頁面，強制重新加載
      router.go(0); // 重新加載當前頁面
    } else {
      // 如果是不同頁面，正常導航
      router.push(targetPath);
    }
  } else {
    if (['buyerboard'].includes(routeName)) {
      alert('此功能正在開發中');
    } else {
      console.warn('未知的路由名稱:', routeName);
    }
  }
}

// 登出模態框顯示狀態
const logoutModalVisible = ref(false)

// 顯示登出確認模態框
function showLogoutModal() {
  logoutModalVisible.value = true
}

// 確認登出
function confirmLogout() {
  userStore.logout()
  router.push('/login')
  logoutModalVisible.value = false
}

// 處理滑鼠進入sidebar
function handleMouseEnter() {
  setSidebarHovered(true)
}

// 處理滑鼠離開sidebar
function handleMouseLeave() {
  setSidebarHovered(false)
}

// 組件掛載時載入設定
onMounted(async () => {
  // 載入後台設定
  await loadBackendConfig()

  // 根據後台設定初始化側邊欄收合狀態
  setSidebarCollapsed(getSidebarCollapsed())

  // 如果有token但沒有用戶信息，驗證token並獲取用戶信息
  if (userStore.isLoggedIn && !userStore.user) {
    try {
      const isValid = await userStore.validateToken()
      if (!isValid) {
        // Token無效，重定向到登入頁
        router.push('/login')
        return
      }
    } catch (error) {
      console.error('驗證用戶信息失敗:', error)
      return
    }
  }
})

// 組件卸載時清理定時器
onUnmounted(() => {
  productRequestsStore.stopPolling()
})

// 監聽用戶登入狀態變化
watch(() => userStore.isLoggedIn, (isLoggedIn) => {
  if (isLoggedIn && userStore.user) {
    // 用戶登入成功，開始輪詢
    productRequestsStore.startPolling()
  } else {
    // 用戶登出，停止輪詢
    productRequestsStore.stopPolling()
  }
}, { immediate: true }) // 立即執行一次，處理頁面刷新時的狀態

// 監聽路由變化，當進入產品代尋留言板頁面時立即更新數量
watch(route, (newRoute) => {
  if (newRoute.name === 'productRequests') {
    // 延遲一下再更新，確保頁面操作完成
    setTimeout(() => {
      productRequestsStore.refreshUnreadCount()
    }, 1000)
  }
})
</script>

<style scoped>
.sidebar {
  width: 186px;
  /* background 將由動態樣式設定 */
  color: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
  height: 100vh;
  position: relative;
  z-index: 1000;
  transition: width 0.3s ease;
}

.sidebar.collapsed {
  width: 60px;
}

.logo {
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.05);
  cursor: pointer;
  transition: all 0.2s ease;
}

.logo:hover {
  background: rgba(255, 255, 255, 0.08);
}

.logo-icon {
  margin-bottom: 8px;
  opacity: 0.9;
}

.logo h3 {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.95);
  text-align: center;
  line-height: 1.2;
}

/* 收合按鈕已移除，側邊欄通過滑鼠懸停展開 */

.nav-menu {
  flex: 1;
  padding: 8px 0;
  overflow-y: auto;
}

.nav-item {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
  font-weight: 400;
  margin: 1px 0;
  position: relative;
}

.nav-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.nav-item.active {
  background-color: rgba(255, 255, 255, 0.15);
  border-left: 4px solid #adb5bd;
  color: #ffffff;
  font-weight: 500;
  box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.1);
}

.nav-item.active .icon {
  opacity: 1;
  color: #ffffff;
}

.nav-item.active span {
  color: #ffffff;
  font-weight: 500;
}

.nav-item .icon {
  margin-right: 12px;
  opacity: 0.8;
  flex-shrink: 0;
}

.nav-item span {
  font-size: 13px;
  font-weight: 400;
}

.special-action {
  padding: 8px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.special-btn {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  margin: 0 12px;
  border-radius: 6px;
  font-weight: 500;
  color: white;
}

.special-btn:hover {
  background: linear-gradient(135deg, #868e96 0%, #5a6268 100%);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.special-btn.active {
  background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);
  color: #6c757d;
  border: 2px solid #6c757d;
  font-weight: 600;
  box-shadow: 0 2px 12px rgba(108, 117, 125, 0.3);
}

.special-btn.active .icon {
  color: #6c757d;
}

.special-btn.active span {
  color: #6c757d;
  font-weight: 600;
}



/* 滾動條樣式 */
.nav-menu::-webkit-scrollbar {
  width: 4px;
}

.nav-menu::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}

.nav-menu::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.nav-menu::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* 未讀留言提醒小紅點樣式 */
.unread-badge {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: #ff4d4f;
  color: white;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 600;
  min-width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  animation: pulse 2s infinite;
}

/* 脈衝動畫效果 */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 77, 79, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(255, 77, 79, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 77, 79, 0);
  }
}

/* 登出按鈕樣式 */
.logout-item {
  /* background 將由動態樣式設定 */
  margin: 10px 12px 0 12px;
  border-radius: 6px;
  font-weight: 500;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: calc(100% - 24px);
  max-width: 160px;
  align-self: center;
}

.logout-item:hover {
  /* 使用較亮的主題色彩作為hover效果 */
  filter: brightness(1.1);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.logout-item .icon {
  color: white;
  opacity: 0.9;
}

.logout-item span {
  color: white;
  font-weight: 500;
}
</style>